const { ValidationError } = require('@plastiq/external-api-errors')

const BaseValidator = require('./BaseValidator')
const { STRING_POSTAL_CODE_COUNTRY } = require('./constants')
const { isValidPostalCode } = require('./helpers')

class PostalCodeValidator {
  static validate(argument, argumentCountry, argumentName) {
    BaseValidator.guardAgainstNullOrUndefined(argument, argumentName)
    validatePostalCodeFormat(argument, argumentCountry, argumentName)
  }
}

function validatePostalCodeFormat(argument, argumentCountry, argumentName) {
  if (!isValidPostalCode(argument, STRING_POSTAL_CODE_COUNTRY(argumentCountry).format)) {
    throw new ValidationError(`Invalid ${argumentCountry} postal code: ${argumentName}`, argument)
  }
}

module.exports = PostalCodeValidator
